import React, { ButtonHTMLAttributes } from 'react';

import { OrderAction, OrderSide } from 'stores/ui/orderPanel/orderPanel';
import { asCents } from 'utils/caseing';
import { isValidPrice } from 'utils/price';

import { NumberChangeAnimationWrapper } from '../Animation';
import Text from '../Text';
import Button from './Button';
import { ButtonRank } from './Button';

interface PriceButtonProps {
    action: OrderAction;
    side: OrderSide;
    price?: number;
    disabled?: boolean;
    rank?: ButtonRank;
    onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void;
    fullWidth?: boolean;
    buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
}

const PriceButton = ({ action, side, price = 0, ...commonButtonProps }: PriceButtonProps): JSX.Element => {
    const leadingText = (
        <Text.Emphasis.x20>{(action === 'buy' ? 'Buy ' : 'Sell ') + (side === 'yes' ? 'Yes' : 'No')}</Text.Emphasis.x20>
    );
    const priceText = <Text.Heading.x10>{isValidPrice(price) ? asCents(price) : '--¢'}</Text.Heading.x10>;

    const { buttonProps, ...otherCommonButtonProps } = commonButtonProps;

    // Hack to sneak formatted and animated text into the button.
    const formattedText = (
        <NumberChangeAnimationWrapper number={price}>
            {leadingText}
            &nbsp;
            {priceText}
        </NumberChangeAnimationWrapper>
    ) as unknown as string;

    return (
        <Button
            text={formattedText}
            size={'medium'}
            variant={action === 'sell' ? 'sell' : side}
            buttonProps={{ style: { width: 122, ...buttonProps?.style }, ...buttonProps }}
            {...otherCommonButtonProps}
        />
    );
};

export default PriceButton;
